module.exports = __webpack_public_path__ + "assets/discourse.bb7dac69.svg";